/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getList } from '../fn/item-extra-controller/get-list';
import { GetList$Params } from '../fn/item-extra-controller/get-list';
import { ItemExtra } from '../models/item-extra';

@Injectable({ providedIn: 'root' })
export class ItemExtraControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `itemExtraControllerGetList()` */
  static readonly ItemExtraControllerGetListPath = '/item-extras';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList$Response(params?: GetList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ItemExtra>>> {
    return getList(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getList(params?: GetList$Params, context?: HttpContext): Observable<Array<ItemExtra>> {
    return this.getList$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ItemExtra>>): Array<ItemExtra> => r.body)
    );
  }

}
